<div id="client-details-page">
    @if(clientLoaded | async) {
    <div>
        <div id="client-info">
            <div class="client-info-col">
                <div class="client-info-item">
                    <div class="label">Nazwa</div>
                    <div class="value">{{client.name}}</div>
                </div>
                <div class="client-info-item">
                    <div class="label">Adres</div>
                    <div class="value">{{client.address}}</div>
                    <div class="value">
                        <span>{{client.postCode}}, {{client.city}}, {{client.country | dict: countries}}</span>
                    </div>
                </div>
            </div>
            <div class="client-info-col">
                <div class="client-info-item">
                    <div class="label">Data utworzenia</div>
                    <div class="value">{{client.createDate | date:'dd-MM-yyyy'}}</div>
                </div>
                <div class="client-info-item">
                    <div class="label">Dane kontaktowe</div>
                    <div class="value">{{client.phone}}</div>
                    <div class="value">{{client.email}}</div>
                </div>
            </div>
            <div class="client-info-col">
                <div class="client-info-item">
                    <div class="label">Numer NIP</div>
                    <div class="value">{{client.vatNumber}}</div>
                </div>
                <div class="client-info-item">
                    <div class="label">Identyfikator</div>
                    <div class="value">{{client.id}}</div>
                </div>
            </div>
        </div>
        <div>
            <mat-tab-group id="client-details-tabs-control" mat-stretch-tabs="false" mat-align-tabs="start"
                (selectedTabChange)="tabChanged($event)" (animationDone)="onTabAnimationDone()">
                <mat-tab label="Płatność">
                    @if(paymentInfo != null) {
                    <div id="payment-details" class="display-flex">
                        <div class="client-info-col">
                            <div class="client-info-item">
                                <div class="label">Okres rozliczeniowy</div>
                                <div class="value" style="display:flex;align-items:center;justify-content:center;gap:4px;">
                                    <span>{{paymentInfo.billingPeriod.from | date:'dd.MM.yyyy'}} -
                                    {{paymentInfo.billingPeriod.to | date:'dd.MM.yyyy'}}</span>
                                    @if(paymentInfo.status == 4) {
                                    <button style="background:none;border:none;cursor:pointer;padding:0 4px;color:#666;font-size:14px;line-height:1;vertical-align:middle;" (click)="showChangeBillingPeriodDialog()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zm17.71-10.21a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
                                    </button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="client-info-col">
                            <div class="client-info-item">
                                <div class="label">Status</div>
                                @if(paymentInfo.status == 1) {
                                <div class="value" style="color:  green;">Aktywny</div>
                                } @else if (paymentInfo.status == 2) {
                                <div class="value" style="color: orange;">Zablokowany</div>
                                } @else if (paymentInfo.status == 3) {
                                <div class="value" style="color: red;">Deaktywowany</div>
                                } @else if (paymentInfo.status == 4) {
                                <div class="value" style="color: blue;">Trial</div>
                                } @else if (paymentInfo.status == 5) {
                                <div class="value" style="color: purple;">Test</div>
                                } @else {
                                <div class="value">Nieznany</div>
                                }
                            </div>
                        </div>
                        <div class="client-info-col">
                            <div class="client-info-item">
                                <div class="label">Karta płatnicza</div>
                                <div class="value card-value">
                                    @if(paymentCard) {
                                    @if(cardBrand == 'visa') {
                                    <svg class="card-brand" viewBox="0 0 48 32" aria-label="Visa">
                                        <rect width="48" height="32" rx="4" fill="#1a1f71"/>
                                        <text x="24" y="22" text-anchor="middle" font-size="14" font-weight="bold" font-style="italic" fill="#fff">VISA</text>
                                    </svg>
                                    } @else if(cardBrand == 'mastercard') {
                                    <svg class="card-brand" viewBox="0 0 48 32" aria-label="Mastercard">
                                        <rect width="48" height="32" rx="4" fill="#fff" stroke="#ddd"/>
                                        <circle cx="19" cy="16" r="9" fill="#eb001b"/>
                                        <circle cx="29" cy="16" r="9" fill="#f79e1b" fill-opacity="0.9"/>
                                    </svg>
                                    } @else {
                                    <span>{{paymentCard.type}}</span>
                                    }
                                    <span>{{paymentCard.mask}}</span>
                                    <a class="btn-link action-icon" title="Szczegóły karty" (click)="showCardDetails()">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="currentColor"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
                                    </a>
                                    } @else {
                                    <span>Brak karty</span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="actions" [matMenuTriggerFor]="actionsMenu" [style.margin-top.px]="10">
                            <mat-menu #actionsMenu="matMenu">
                                <ng-container *rolePermission="'client.block'">
                                    @if(paymentInfo.status == 1) {
                                    <button mat-menu-item (click)="blockClient()">Zablokuj</button>
                                    } @else if(paymentInfo.status == 2) {
                                    <button mat-menu-item (click)="unblockClient()">Odblokuj</button>
                                    } @else if(paymentInfo.status == 3) {
                                    <button mat-menu-item>Aktywuj</button>
                                    }
                                    @if(paymentInfo.status != 3){
                                    <button mat-menu-item (click)="deactivateClient()">Deaktywuj</button>
                                    } @else {
                                    <button mat-menu-item (click)="deleteClient()">Usuń</button>
                                    }
                                    <button mat-menu-item (click)="showSettlementDialog()">Rozlicz</button>
                                    <hr style="margin: 0 2px;" color="lightgrey" size="1"/>
                                </ng-container>
                                <button mat-menu-item (click)="showCurrentBillingReport()">Raport</button>
                            </mat-menu>
                        </div>
                    </div>
                    }
                    @if(paymentHistory != null) {
                    <div class="label section-label">Historia płatności</div>
                    <div id="payment-history" #paymentHistoryRef [style.height]="paymentHistoryHeight">
                        <mat-table [dataSource]="paymentHistory">
                            <ng-container matColumnDef="title">
                                <mat-header-cell *matHeaderCellDef>Tytuł</mat-header-cell>
                                <mat-cell *matCellDef="let item">{{item.title}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="number">
                                <mat-header-cell *matHeaderCellDef class="cell-center">Numer faktury</mat-header-cell>
                                <mat-cell *matCellDef="let item" class="cell-center">{{item.invoiceNumber}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="date">
                                <mat-header-cell *matHeaderCellDef class="cell-center">Data</mat-header-cell>
                                <mat-cell *matCellDef="let item" class="cell-center">{{item.date | date:'dd-MM-yyyy
                                    HH:mm'}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="amount">
                                <mat-header-cell *matHeaderCellDef class="cell-center">Kwota</mat-header-cell>
                                <mat-cell *matCellDef="let item" class="cell-center">{{item.amount}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef class="cell-center">Status</mat-header-cell>
                                <mat-cell *matCellDef="let item" class="cell-center">
                                    @if(item.status == 2) {
                                        <span class="payment-status payment-status--paid">
                                            <svg viewBox="0 0 24 24" class="status-icon"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5l-4-4 1.41-1.41L10 13.67l6.59-6.59L18 8.5l-8 8z"/></svg>
                                            Opłacono
                                        </span>
                                    } @else {
                                        <span class="payment-status payment-status--unpaid">
                                            <svg viewBox="0 0 24 24" class="status-icon"><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/></svg>
                                            Nieopłacono
                                        </span>
                                    }
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="transaction">
                                <mat-header-cell *matHeaderCellDef class="cell-center">Transakcja</mat-header-cell>
                                <mat-cell *matCellDef="let item" class="cell-center">{{item.transaction}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                <mat-cell *matCellDef="let item" class="cell-right">
                                    <div class="row-actions">
                                        <a class="btn-link action-icon action-info" title="Szczegóły" (click)="showDetails(item)">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="currentColor"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
                                        </a>
                                        <ng-container *rolePermission="'client.invoice.download'">
                                            @if(item.invoiceNumber) {
                                            <a class="btn-link action-icon" title="Pobierz fakturę"
                                                (click)="downloadInvoicePdf(item)">
                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 -960 960 960" fill="currentColor"><path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg>
                                            </a>
                                            }
                                        </ng-container>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row
                                *matHeaderRowDef="['title', 'number', 'date', 'amount', 'status', 'transaction', 'actions']; sticky: true"></mat-header-row>
                            <mat-row
                                *matRowDef="let item; columns: ['title', 'number', 'date', 'amount', 'status', 'transaction', 'actions']"></mat-row>
                        </mat-table>
                    </div>
                    }
                </mat-tab>
                <mat-tab label="Użytkownicy">
                    <mat-table [dataSource]="users">
                        <ng-container matColumnDef="login">
                            <mat-header-cell *matHeaderCellDef>Email / Login</mat-header-cell>
                            <mat-cell *matCellDef="let user">{{user.login}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="internalId">
                            <mat-header-cell *matHeaderCellDef class="cell-center">Identyfikator</mat-header-cell>
                            <mat-cell *matCellDef="let user" class="cell-center">{{user.internalId}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="active">
                            <mat-header-cell *matHeaderCellDef class="cell-center">Aktywny</mat-header-cell>
                            <mat-cell *matCellDef="let user" class="cell-center"><span
                                    [outerHTML]="user.active | boolToImg"></span></mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="loginAsAdmin">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let user" class="cell-right">
                                <a ng-href="#" class="btn-link" target="_blank" rel="noopener noreferrer"
                                    *rolePermission="'client.loginAsUser'"
                                    (click)="loginAsUser(user.id)">Zaloguj</a>
                            </mat-cell>
                        </ng-container>
                        <mat-header-row
                            *matHeaderRowDef="['login', 'internalId', 'active', 'loginAsAdmin']"></mat-header-row>
                        <mat-row
                            *matRowDef="let user; columns: ['login', 'internalId', 'active', 'loginAsAdmin']"></mat-row>
                    </mat-table>
                </mat-tab>
                <mat-tab label="Cenniki">
                    <div id="cenniki-page" #cennikiPageRef [style.height]="cennikiContainerHeight">
                        <div class="cenniki-toolbar">
                            <a ng-href="#" class="btn-link add-pricelist-link" (click)="openCreatePricelistDialog()">Dodaj cennik</a>
                        </div>
                        <mat-table [dataSource]="pricelists" class="selectable-table">
                            <ng-container matColumnDef="createDate">
                                <mat-header-cell *matHeaderCellDef>Date utworzenia</mat-header-cell>
                                <mat-cell *matCellDef="let pricelist">{{pricelist.createDate | date:'dd-MM-yyyy HH:mm'}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="validFrom">
                                <mat-header-cell *matHeaderCellDef>Ważny od</mat-header-cell>
                                <mat-cell *matCellDef="let pricelist">{{pricelist.validFrom | date:'dd-MM-yyyy'}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="validTo">
                                <mat-header-cell *matHeaderCellDef>Ważny do</mat-header-cell>
                                <mat-cell *matCellDef="let pricelist">{{pricelist.validTo ? (pricelist.validTo | date:'dd-MM-yyyy') : 'Bezterminowo'}}</mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="['createDate', 'validFrom', 'validTo']"></mat-header-row>
                            <mat-row *matRowDef="let pricelist; columns: ['createDate', 'validFrom', 'validTo']"
                                (click)="selectPricelist(pricelist)"></mat-row>
                        </mat-table>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
    }
</div>
